var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7DFF8A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1080,251v340.2c0,0-70.2,16.2-86.4,16.2s-59.4,16.2-91.8-16.2c-48.6-48.6-232.2-237.6-232.2-237.6 s-27-32.4-75.6-5.4l-81,48.6c-27,16.2-70.2,5.4-86.4-21.6l0,0c-21.6-32.4-10.8-75.6,21.6-91.8c64.8-37.8,167.4-97.2,205.2-118.8 c32.4-21.6,59.4-21.6,108,21.6c59.4,48.6,108,97.2,108,97.2s21.6,10.8,43.2,10.8C950.4,283.4,1080,251,1080,251z M426.6,839.6 c-16.2-16.2-199.8-216-216-232.2c-21.6-27-64.8-21.6-91.8,0c-27,27-43.2,75.6-21.6,102.6c21.6,27,189,205.2,216,232.2 c21.6,27,81,16.2,108-10.8C448.2,904.4,453.6,861.2,426.6,839.6z M842.4,726.2c27-27,21.6-75.6-5.4-102.6 c-145.8-151.2-91.8-91.8-189-194.4c0,0-32.4-37.8-70.2-16.2c-10.8,5.4-27,16.2-48.6,27c-48.6,32.4-113.4,16.2-145.8-37.8l-16.2-10.8 c-32.4-54-16.2-118.8,32.4-151.2l91.8-59.4c0,0-21.6-32.4-86.4-32.4c-64.8,0-199.8,97.2-199.8,97.2s-43.2,27-97.2,5.4L0,213.2V602 c0,0,32.4,10.8,59.4,21.6c5.4-16.2,16.2-37.8,32.4-48.6c43.2-43.2,124.2-48.6,162,0c27,27,199.8,216,216,232.2 c27,27,32.4,64.8,27,97.2C507.6,915.2,739.8,839.6,842.4,726.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.841f393cfc7be97b5c2354d8d4ac821e.svg";
export { ForwardRef as ReactComponent };